import React from 'react';
import Header from './components/Header';
import * as Pages from '../config/pagesConfig';
import { LightBlueButton } from '../components';
import { useSelector } from 'react-redux';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { routesName } from '../constants/routes-name';
import { Box } from '@mui/material';

const Component = () => {
  const { user } = useSelector(({ user }) => user);

  if (user) {
    return <Navigate to={routesName.supplierAllTenderListing} />;
  }
  return <HomeTendersPage />;
};

const HomeTendersPage = () => {
  const { user } = useSelector(({ user }) => user);
  const location = useLocation();

  return (
    <div>
      {/* <Header page="tenders" /> */}
      <div className=" flex justify-center md:px-8 px-2 md:py-16 py-8">
        <Box
          sx={{ width: { lg: '80%', md: '95%', sm: '100%', xs: '100%' } }}
          className="space-y-12"
          //className="lg:w-[80%] md:w-[95%] w-[100%] space-y-12"
        >
          <div className="md:px-16 px-6 ">
            <div className="flex flex-col gap-5">
              {!user && (
                <div className="text-2xl font-bold">Lastest Tenders</div>
              )}
              <div className="relative overflow-x-auto">
                {!user && (
                  <table className="w-full text-sm text-left">
                    <thead className="text-sm text-white bg-[var(--blue)]">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-nowrap text-center"
                        >
                          Title
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-nowrap text-center"
                        >
                          Deadline
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-nowrap text-center"
                        >
                          Organisation
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-nowrap text-center"
                        >
                          Tender Process
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-nowrap text-center"
                        >
                          Reference No.
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-nowrap text-center"
                        >
                          Country
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-nowrap text-center"
                        >
                          Category
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="odd:bg-white  even:bg-gray-50">
                        <th className="px-6 py-4 font-[400]">
                          Change management - Supply chain consultant
                        </th>
                        <td className="px-6 py-4">5 July 2025</td>
                        <td className="px-6 py-4">
                          Save the Children International
                        </td>
                        <td className="px-6 py-4">
                          Request for Proposal (RFP)
                        </td>
                        <td className="px-6 py-4">RFQ-EXW-GLO-2023-03</td>
                        <td className="px-6 py-4">Panama</td>
                        <td className="px-6 py-4">
                          Consulting services & trainings
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
                {user && location.pathname === routesName.tenders && (
                  <Pages.TenderListing headers={false} />
                )}
                {user && location.pathname === routesName.my_tenders && (
                  <Pages.MyTenderListing headers={false} />
                )}
              </div>
            </div>
          </div>

          {!user && (
            <div className="flex justify-center pt-12">
              <Link to={routesName.pricing}>
                <LightBlueButton size="large">
                  Join Aid-LINK and get all tenders
                </LightBlueButton>
              </Link>
            </div>
          )}
        </Box>
      </div>
    </div>
  );
};

export default Component;
